<template>
    <rkm-form ref="Form">
        <rkm-area
            type="section"
            title="BUSCAR JORNADAS CADASTRADAS"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="jornada.periodo"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário Inicial"
                        v-model="jornada.horaInicial"
                        :validations="jornada.horaFim ? validations.horaInicial : {}"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário Final"
                        v-model="jornada.horaFim"
                        :validations="jornada.horaInicial ? validations.horaFim : {}"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">

                <rkm-col cols="6">
                    <rkm-form-checkbox-group
                        label="Dias da semana"
                        v-model="jornada.diasSemana"
                        :options="form.diasSemana"
                        :validations="validations.diasSemana"
                        text-field="nome"
                        value-field="id"
                        buttons
                        button-color="outline-primary"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.tipos"
                        label="Tipo de Jornada"
                        show-default-option
                        text-field="nome"
                        v-model="jornada.tipoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Número de vagas"
                        number
                        v-model="jornada.vagas"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(search)"
                        color="primary"
                    >
                        Buscar
                    </rkm-button>
                    <rkm-button
                        :label="false"
                        @click.stop="resetForm"
                        color="secondary"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>
     </rkm-form>
</template>

<script>

// Moment.
import moment from 'moment'

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

export default {
    computed:{
        validations() {
            return {
                diasSemana: { required: true },
                horaInicial: {
                    max_value: this.jornada.horaFim.substr(0, 5),
                 },
                 horaFim: {
                    min_value: this.jornada.horaInicial.substr(0, 5),
                 },
            }
        },
    },
    created() {

        this.repositories = {
            jornada: this.getConectaSusRepository('exameLaboratorial.jornada')
        },
        this.setDefaultValues()
    },
    data:() => ({
        jornada: {
            data: null,
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            diasSemana:null,
            semanaId: null,
            tempoAtendimento: '',
            tipoId: null,
            tipoNome: null,
            unidadeId: null,
            vagas: '',
            periodo: {
                start: null,
                end: null,
            },
        },
        dataAtual: '',
    }),
    methods:{
        ...mapActions(['setLoading', 'unsetLoading']),
        getPrincipal(infraestruturaPrincipal) {

            let localAtendimento = infraestruturaPrincipal.find(u => u.principal === true)

            if(localAtendimento ){

                this.jornada.infraestruturaId = localAtendimento.id
            } else {

                this.jornada.infraestruturaId = null
            }
        },
        search() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                        let buscaJornada = []

                        this.jornada.diasSemana.forEach(diasSemana => {

                            this.model.jornadas.filter(a => a.semanaId == diasSemana).map(aplicacao => {

                                buscaJornada.push(aplicacao)
                            })
                        })

                        if (this.jornada.vagas){
                            buscaJornada = buscaJornada.filter(jornada => jornada.vagas == this.jornada.vagas)
                        }

                        if (this.jornada.tipoId){
                            buscaJornada = buscaJornada.filter(jornada => jornada.tipoId == this.jornada.tipoId)
                        }

                        if (this.jornada.horaInicial){
                            buscaJornada = buscaJornada.filter(jornada => jornada.horaInicial >= this.jornada.horaInicial.substr(0, 5))
                        }

                        if (this.jornada.horaFim){
                            buscaJornada = buscaJornada.filter(jornada => jornada.horaFim <= this.jornada.horaFim.substr(0, 5))
                        }

                        if (this.jornada.periodo){

                            const start = moment(this.jornada.periodo.start).subtract(1, 'day')
                            const end = moment(this.jornada.periodo.end).add(1, 'day')

                            buscaJornada = buscaJornada.filter(jornada => moment(jornada.data, 'DD/MM/YYYY').isBetween(start, end))
                        }

                        this.model.jornadasNotSave = buscaJornada

                        this.$emit('handleBlur')
            })
        },
        validate() {

            return this.$refs.Form.validate()
        },
        resetForm() {

            this.jornada.vagas = ''
            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''

            this.jornada.tipoId = null
            this.model.jornadasNotSave = null

            this.$emit('handleBlur')

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        setDefaultValues() {

            this.jornada.periodo.start = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.jornada.periodo.end = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        disabledSemanas(){

            this.form.diasSemana.forEach(s => s.disabled = true)
        }
    },
    mixins: [ repository, error, object, data, stringCase ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'jornada.periodo': {
            deep: true,
            handler: function (periodo) {

                this.jornada.diasSemana = []
                this.disabledSemanas()

                if(periodo.end){

                    var periodoInicial = moment(periodo.start, 'YYYY/MM/DD');
                    var periodoFinal = moment(periodo.end, 'YYYY/MM/DD');

                    var diaInicial   = periodoInicial.format('D');
                    var mesInicial = periodoInicial.format('M');
                    var anoInicial  = periodoInicial.format('YYYY');

                    var diaFinal   = periodoFinal.format('D');
                    var mesFinal = periodoFinal.format('M');
                    var anoFinal  = periodoFinal.format('YYYY');

                    var dataInicial = new Date(anoInicial,mesInicial - 1,diaInicial);
                    var dataFim = new Date(anoFinal,mesFinal -1 ,diaFinal);

                    for (var dataInserida = dataInicial; dataInserida <= dataFim; dataInserida.setDate(dataInserida.getDate() + 1)) {

                        var data = moment(dataInserida, 'DD/MM/YYYY').toDate()

                        var dia = data.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == dia)){

                            this.jornada.diasSemana.push(dia)
                        }
                    }

                } else {

                    if(periodo.start){

                        var dataStart = moment(periodo.start, 'DD/MM/YYYY').toDate()

                        var diaStart = dataStart.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == diaStart)){

                            this.jornada.diasSemana.push(diaStart)
                        }
                    }
                }

                if(periodo.start || periodo.end){

                    let indices = []

                    if(periodo.start){

                        let dataStart = moment(periodo.start, 'DD/MM/YYYY').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataStart.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.end){

                        let dataEnd = moment(periodo.end, 'DD/MM/YYYY').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataEnd.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.start && periodo.end){

                        indices = []

                        let dataStart = moment(periodo.start, 'DD/MM/YYYY')
                        let dataEnd = moment(periodo.end, 'DD/MM/YYYY')

                        let indice = 0

                        while (dataStart.isSameOrBefore(dataEnd) && indice < 7) {

                            const index = this.form.diasSemana.findIndex(d => d.id == dataStart.toDate().getDay() + 1)
                            indices.push(index)

                            dataStart.add(1, 'd')

                            indice++
                        }
                    }
                    indices.forEach(indice => {

                        this.form.diasSemana[indice].disabled = false
                    })
                }
            }
        }
    }
}
</script>